import { findAllWhere, findOneWhere } from './my_simple_functions.js';
import {
    partnership,
    partnership_member,
    business,
    branch, dish, branch_dish, location,
    search_word,
    place
} from './DB';

//===============================================================================
//
//                               ***  ROUTES  ***
//
//===============================================================================

// Get all the dishes of a given business
export const getBusinessDishes = (business_id) => {
    return findAllWhere(dish.rows, { business_id });
    //throw "No business dishes";
}

// Get all the  dishes, given the branch ID and branch Code
export const getBranchDishes = (business_id, branch_code) => {
    // find branch first
    const branch1 = findOneWhere(branch.rows, { business_id, branch_code });
    const brDish = findAllWhere(branch_dish.rows, { branch_id: branch1.id});
    let dishes = [];
    brDish.forEach(dish1 => {
        let bDish = findOneWhere(dish.rows, {id: dish1.dish_id});
        dishes.push({...bDish, branch_price: dish1.branch_price });
    });
    return dishes;
    //throw "No branch dishes";
    //throw "Branch code provided is not correct";
}

// Get all the  dishes, given the branch ID
export const getBranchDishesByBranchID = (id) => {
    // find branch first
    let dishes = [];
    try {
        const branch1 = findOneWhere(branch.rows, { id });
        const brDish = findAllWhere(branch_dish.rows, { branch_id: branch1.id});
        brDish.forEach(dish1 => {
            let bDish = findOneWhere(dish.rows, {id: dish1.dish_id});
            dishes.push({...bDish, branch_price: dish1.branch_price });
        });
    } catch (error) {
        if (error == "Record not found") return []; 
    }
    return dishes;
    //throw "No branch dishes";
    //throw "Branch code provided is not correct";
}

// Get all the branches of a particular business
export const getBusinessBranches = (business_id) => {
    return findAllWhere(branch.rows, { business_id });
    //throw "No branch for the business";
}
// Get all the branches of a particular business
export const getLocationBranches = (location_id) => {
    return findAllWhere(branch.rows, { location_id });
    //throw "No branch for the business";
}
// Get all membership for owner
export const getMemebershipsForOwner = (enterpreneur_id) => {
    return findAllWhere(partnership_member.rows, { enterpreneur_id });
    // throw "No registered a partnership";
}
// Get Partnership by id
export const findPartnershpByID = (id) => {
    return findOneWhere(partnership.rows, { id });
}
// Get Business by ID
export const findBusinessByID = (id) => {
    return findOneWhere(business.rows, { id });
}

// Get all the businesses for a particular partnership
export const getBusinessForPartnership = (partnership_id) => {
    return findAllWhere(business.rows, { partnership_id });
    // throw "No business dishes";
}

// GEt all the businesses of a particular enterpreneur
export const getBusinessesForOwner = (enterpreneur_id) => {
    const memberships = getMemebershipsForOwner(enterpreneur_id);
    const partnerships = [];
    for (let i = 0; i < memberships.length; i++) {
        partnerships.push(findPartnershpByID(memberships[i].partnership_id));
    }
    
    const businesses = [];
    for (let i = 0; i < partnerships.length; i++) {
        const buzinezzes = getBusinessForPartnership(partnerships[i].id);
        businesses.push(...buzinezzes);
    }
    if (!businesses && !businesses.length) throw "No business dishes";
    else return businesses;
}

// Get all the members of a partnership
export const getPartnershipMembers = (partnership_id) => {
    return findAllWhere(partnership_member.rows, { partnership_id });
}

// Get all the businesses of a particular type
export const getAllBusinessesOfType = (food_type) => {
    return findAllWhere(business.rows, { food_type });
}

// Get partnership by code
export const getPartnershpByCode = (partnership_code) => {
    return findOneWhere(partnership.rows, { partnership_code });
}

//====================================================================

// Get location  by Province
export const getAllLocationsByProvince = (province_id) => {
    return findAllWhere(location.rows, { province_id });
}
// Get location by city
export const getAllLocationsByCity = (city_id) => {
    return findAllWhere(location.rows, { city_id });
}
// Get location by Township
export const getAllLocationsByTownship = (township_id) => {
    return findAllWhere(location.rows, { township_id });
}
// Get location by Block
export const getAllLocationsByBlock = (block_id) => {
    return findAllWhere(location.rows, { block_id });
}
export const getAllLocationsWellknownName = (wellknown_name) => {
    return findAllWhere(location.rows, { wellknown_name });
}

// Get location by all props
export const findLocations = (keyword, by) => {
    let locations = [];
    if (by == 'All') {
        locations = getAllLocationsByProvince(keyword);
        locations = locations.concat(getAllLocationsByCity(keyword));
        locations = locations.concat(getAllLocationsByTownship(keyword));
        locations = locations.concat(getAllLocationsByBlock(keyword));
        locations = locations.concat(getAllLocationsWellknownName(keyword));
    } else if (by === 'province') locations = getAllLocationsByProvince(keyword);
    else if (by === 'city') locations = getAllLocationsByCity(keyword);
    else if (by === 'township') locations = getAllLocationsByTownship(keyword);
    else if (by === "block") locations = getAllLocationsByBlock(keyword);
    // else if (by === 'wellknown_name') locations = getAllLocationsWellknownName(keyword);
    
    return locations;
}

export const findBranchesInLocations = (place_id = NaN, keyword, by) => {
    let locations = [];
    // If keyword is a number
    if (!isNaN(place_id)) locations = findLocations(place_id, by);
    else locations = getAllLocationsWellknownName(keyword);

    let branches = [];
    if (!locations || !locations.length) {
        return branches;
    } else {
        for (let i = 0; i < locations.length; i++) {
            branches = branches.concat(getLocationBranches(locations[i].id));
        }
        let businesses = [];
        if (!branches || branches.length === 0) {
            return branches;
        } else {
            branches.forEach(branch => {
                const buzznz = findBusinessByID(branch.business_id);
                const branchDish = getBranchDishes(branch.business_id, branch.branch_code);
                const dishes = [];
                for (let i = 0; i < branchDish.length; i++) {
                    if (i === 3) break;
                    dishes.push(branchDish[i]);
                }
                const location1 = Object.assign({}, findOneWhere(location.rows, { id: branch.location_id }));
                const block = findOneWhere(place.rows, { id: location1.block_id }),
                township = findOneWhere(place.rows, { id: location1.township_id }),
                city = findOneWhere(place.rows, { id: location1.city_id }),
                province = findOneWhere(place.rows, { id: location1.province_id });

                const locationNames = { wellknown_name: location1.wellknown_name,
                    block: block.name,
                    township: township.name,
                    city: city.name,
                    province: province.name
                }
                businesses.push({...buzznz, branch_id: branch.id,
                    branch_code: branch.branch_code,
                    //location: findOneWhere(location.rows, { id: branch.location_id }), dishes
                    location: locationNames
                });
            });
            return businesses;
        }
    }
}

export const getTenMatchingWords = (key) => {
    const matchWords = [];
    for (let i = 0; i < search_word.rows.length; i++) {
        const search_phrase = search_word.rows[i].search_phrase;
        if (search_phrase.toLowerCase().match(key.toLowerCase())) matchWords.push(search_word.rows[i]);
        // Only get Ten matches 
        if (matchWords.length > 9) break;
    }
    return matchWords;
}